import { http } from './config';

const PARCEIRO_PATH = 'users/parceiros';

export default {
  get: ({ code }) => http.get(`${PARCEIRO_PATH}/${code}`),

  listar: ({ page, nome }) =>
    http.get(`${PARCEIRO_PATH}?page=${page}&nome=${nome}`),

  salvar: parceiro => http.post(PARCEIRO_PATH, parceiro),

  atualizar: parceiro =>
    http.post(`${PARCEIRO_PATH}/${parceiro._id}`, parceiro),

  deletar: parceiro => http.delete(`${PARCEIRO_PATH}/${parceiro._id}`)
};
